import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const ConsultSlice = createSlice({
  name: "ConsultReducer",
  initialState,
  reducers: {
    setConsultList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setConsultList } = ConsultSlice.actions;

export default ConsultSlice.reducer;
